import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-google-workspace-service',
  templateUrl: './google-workspace-service.component.html',
  styleUrl: './google-workspace-service.component.scss',
})
export class GoogleWorkspaceServiceComponent {
  public contentData: object[]

  constructor(public translate: TranslateService) {}
  ngOnInit() {
    this.showMockContent()
  }
  showMockContent() {
    const lang = this.translate.currentLang
    const baseUrl = 'https://flowaccountcdn.com/new_landing/image/google-workspace/service/icon'

    this.contentData = [
      {
        image: `${baseUrl}/online_accounting.png`,
        link: `/${lang}`,
      },
      {
        image: `${baseUrl}/business_registration.png`,
        link: `/${lang}/business-registration`,
      },
      {
        image: `${baseUrl}/seminars_for_business.png`,
        link: `/${lang}/seminars`,
      },
      {
        image: `${baseUrl}/accounting_firm.png`,
        link: `/${lang}/accountingfirm/businessowner`,
      },
    ]
  }
}
